import HomeFull from "@/assets/icons/home-full.svg";
import { Button } from "@/components/ui/button";
import NavItem from "@/domain/entities/navbar/NavItem";
import MailSource from "@/domain/enums/MailSource";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import GeneralItem from "./GeneralItem";
import SectionTitle from "./SectionTitle";

const generalFolderPaths = Object.values(MailSource).map((m) => `/${m}`);

type GeneralSectionAccordionProps = {
    items: NavItem[];
};

const GeneralSectionAccordion = ({ items }: GeneralSectionAccordionProps) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const isGeneralFolder = generalFolderPaths.some(
            (path) => pathname === path || pathname.startsWith(`${path}/`),
        );
        if (!isGeneralFolder) {
            setIsOpen(false);
        }
    }, [pathname]);

    return (
        <div>
            <Button
                className="h-auto w-full rounded-lg px-0 py-2 hover:bg-surface-primary [&_>div]:w-full [&_>div]:justify-between"
                onClick={() => setIsOpen(!isOpen)}
                variant="ghost"
            >
                <SectionTitle
                    icon={HomeFull}
                    label={t("navbar.mainMenu.inbox")}
                />
                {isOpen ? (
                    <ChevronUp className="h-4 w-4 text-text-caption" />
                ) : (
                    <ChevronDown className="h-4 w-4 text-text-caption" />
                )}
            </Button>
            {isOpen && (
                <div className="mt-1 flex flex-col gap-1">
                    {items?.map((item: NavItem) => (
                        <GeneralItem
                            key={item.id}
                            count={item.itemCount}
                            id={item.id as string}
                            label={t(`navbar.mainMenu.${item.id}`)}
                            to={`/${item.id}`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default GeneralSectionAccordion;
